import React from 'react';

interface HexContainerProps {
  image?: string;
  title?: string;
  subtitle?: string;
  className?: string;
  onClick?: () => void;
}

const HexContainer: React.FC<HexContainerProps> = ({
  image,
  title,
  subtitle,
  className = '',
  onClick
}) => {
  return (
    <div
      className={`relative w-72 h-72 ${className}`}
      onClick={onClick}
    >
      {/* SVG Hexagon Background from HexContainer.svg file */}
      <div
        className="w-full h-full absolute inset-0"
        style={{
          backgroundImage: `url('/HexContainer.svg')`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          filter: `drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))`,
        }}
      />
      {/* Content Container */}
      <div
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center text-center w-4/5 h-4/5 py-2 px-8 md:px-6"
      >
        {/* Image */}
        {image && (
          <div className="w-16 h-16 mb-1 overflow-hidden">
            <img
              src={image}
              alt={title || 'Hex container image'}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        {/* Title */}
        {title && (
          <h3
            className="text-lg font-bold text-gray-900 mb-1 leading-tight"
          >
            {title}
          </h3>
        )}

        {/* Subtitle */}
        {subtitle && (
          <p
            className="text-md text-gray-800 leading-tight m-0"
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default HexContainer;